import { useRSStore } from '@/store/useRSStore'
import { readRoleListAPI ,addRoleAPI ,updateRoleAPI , deleteRoleAPI } from '../api/RoleAPI'
import type { userRole, } from '../types/types'

export function useRole() {
  const RSStore = useRSStore()
 
  const onReadRoleList = async () => {
    try {
      const result = await readRoleListAPI()
      console.log("역할 목록 API 호출 성공:")
      RSStore.roleList = result.map((item: any) => ({
        id: item.id,
        name: item.name,
        description: item.description,
        permissions: JSON.parse(atob(item.permissions)),
      }))
      console.log("역할 목록 불러오기 성공:", RSStore.roleList)
    } catch (e) {
      console.error("역할 목록 불러오기 중 에러 발생:", e)
    }
  }
  const onAddRole = async (name: string, permissions: userRole, description: string) => {
    try {
     
      const result = await addRoleAPI(name, permissions, description)
      console.log("역할 추가 완료 id:", result)
      onReadRoleList() // 추가 후 역할 목록 새로고침
    } catch (e) {
      console.error("역할 추가 중 에러 발생:", e)
    }
  }

  const onUpdateRole = async (id: number, name: string, permissions: userRole, description: string) => {
    try {
      const result = await updateRoleAPI(id, name, permissions, description )
      if (result) {
        console.log("역할 업데이트 완료 :", id)
        onReadRoleList() // 업데이트 후 역할 목록 새로고침
      } else {
        console.error("역할 업데이트 실패 입력값 확인 필요:", id)
      }
    } catch (e) {
      console.error("역할 업데이트 중 에러 발생:", e)
    }
  }
    const onDeleteRole = async (id: number) => {
      try {
        const result = await deleteRoleAPI(id)
        if (result) {
          console.log("역할 삭제 성공:", id)
          onReadRoleList() // 삭제 후 역할 목록 새로고침
        }
      } catch (e) {
        console.error("역할 삭제 중 에러 발생:", e)
      }
    }
  
    return { 
      onUpdateRole, 
      onReadRoleList, 
      onDeleteRole, 
      onAddRole 
    }
}
